import { DataProviderIdEnum } from '../enums/data-provider';

export function isBlackKnight(name: string) {
  return name === DataProviderIdEnum.BlackKnight;
}
export function isDataTrace(name: string) {
  return [DataProviderIdEnum.DataTrace, DataProviderIdEnum.DataTraceDTAPI].includes(name as DataProviderIdEnum);
}
